import React from 'react'
import moment from 'moment'
import { Row, Col } from 'react-bootstrap'
import { Card, CardActionArea } from '@material-ui/core'

function DatosBusquedaCpa (props) {
  const { estadoCpa, detalleCompletoCpa, fotoCalado = null, fotoBruto = null, openDialogFoto } = props

  const fechaCupo = moment(detalleCompletoCpa.fechaCupo).format('DD-MM-YYYY')
  const fechaDeIngreso = detalleCompletoCpa.fechaDeIngreso ? moment(detalleCompletoCpa.fechaDeIngreso).format('DD-MM-YYYY HH:mm') : null
  const fechaDeAlta = detalleCompletoCpa.fechaDeAlta ? moment(detalleCompletoCpa.fechaDeAlta).format('DD-MM-YYYY HH:mm') : null
  const fechaDeVencimiento = detalleCompletoCpa.fechaDeVencimiento ? moment(detalleCompletoCpa.fechaDeVencimiento).format('DD-MM-YYYY HH:mm') : null
  const fechaEgresoPlaya = detalleCompletoCpa.fechaDeEgresoPlaya ? moment(detalleCompletoCpa.fechaDeEgresoPlaya).format('DD-MM-YYYY HH:mm') : null
  const fechaDeCalado = detalleCompletoCpa.fechaDeCalado ? moment(detalleCompletoCpa.fechaDeCalado).format('DD-MM-YYYY HH:mm') : null
  const fechaDeAbandono = detalleCompletoCpa.fechaDeAbandono ? moment(detalleCompletoCpa.fechaDeAbandono).format('DD-MM-YYYY HH:mm') : null
  const fechaAsignacionTurno = detalleCompletoCpa.fechaAsignacionTurnoDeSalida ? moment(detalleCompletoCpa.fechaAsignacionTurnoDeSalida).format('DD-MM-YYYY HH:mm') : null
  const fechaDeBruto = detalleCompletoCpa.fechaDeBruto ? moment(detalleCompletoCpa.fechaDeBruto).format('DD-MM-YYYY HH:mm') : null
  const fechaDeDestare = detalleCompletoCpa.fechaDeDestare ? moment(detalleCompletoCpa.fechaDeDestare).format('DD-MM-YYYY HH:mm') : null
  const fechaDeVolcado = detalleCompletoCpa.fechaDeVolcado ? moment(detalleCompletoCpa.fechaDeVolcado).format('DD-MM-YYYY HH:mm') : null
  const cerealVariedad = (estadoCpa.cerealVariedad !== 'UNDEF   ') ? estadoCpa.cerealVariedad : ' - '
  const fechaIngresoCalado = detalleCompletoCpa.fechaDeIngresoCalado ? moment(detalleCompletoCpa.fechaDeIngresoCalado).format('DD-MM-YYYY HH:mm') : null
  const fechaEgresoCalado = detalleCompletoCpa.fechaDeEgresoCalado ? moment(detalleCompletoCpa.fechaDeEgresoCalado).format('DD-MM-YYYY HH:mm') : null
  const fechaRechazoBruto = estadoCpa.fechaDeRechazoEnPesado ? moment(estadoCpa.fechaDeRechazoEnPesado).format('DD-MM-YYYY HH:mm') : null
  const fechaAutorizacionCalado = detalleCompletoCpa.fechaDeAutorizacionAdministrativaCalado
    ? moment(detalleCompletoCpa.fechaDeAutorizacionAdministrativaCalado).format('DD-MM-YYYY HH:mm')
    : null
  const fechaCalleCalado = detalleCompletoCpa.fechaDeAsignacionCalleDeCalado ? moment(detalleCompletoCpa.fechaDeAsignacionCalleDeCalado).format('DD-MM-YYYY HH:mm') : null
  const peritoCompleto = detalleCompletoCpa.peritoCalador && detalleCompletoCpa.peritoCalador.startsWith('{')
    ? detalleCompletoCpa.peritoCalador.split('"') : detalleCompletoCpa.peritoCalador
  const perito = peritoCompleto && peritoCompleto !== detalleCompletoCpa.peritoCalador ? peritoCompleto[5].split(':') : detalleCompletoCpa.peritoCalador

  return (
    <>
      <Row>
        <Col md={3}>
          <h6>Estado del CTG: <b>{detalleCompletoCpa.estadoCtg}</b></h6>
          <h6>Fecha de cupo: <b>{fechaCupo}</b> </h6>
          <h6>Código de cupo: <b>{estadoCpa.codigoCupo}</b></h6>
          <h6>Tipo de cupo: <b>{estadoCpa.tipoCupoLargo}</b></h6>
          <h6>Fecha de vencimiento: <b>{fechaDeVencimiento}</b></h6>
          {detalleCompletoCpa.renspa && <h6>RENSPA: <b>{detalleCompletoCpa.renspa}</b></h6> }
          {estadoCpa.validacionCtg && <h6>Validación CTG: <b>{detalleCompletoCpa.validacionCtg}</b></h6> }
          {estadoCpa.observacionesCtg && <h6>Observaciones CTG: <b>{detalleCompletoCpa.observacionesCtg}</b></h6> }
          {detalleCompletoCpa.codigoDeEmisionElectronica && <h6>Código de emisión electrónica: <b>{detalleCompletoCpa.codigoDeEmisionElectronica}</b></h6>}
          <h6>Cosecha: <b>{estadoCpa.cosecha}</b></h6>
          <h6>Número de CPE: <b>{estadoCpa.cpeSucursal}-{estadoCpa.cpeSecuencia}</b> </h6>
          {detalleCompletoCpa.tarifa && <h6>Tarifa: <b>{detalleCompletoCpa.tarifa}</b> - Tarifa referencia: <b>{detalleCompletoCpa.tarifaReferencia}</b></h6>}
          <h6>Kilómetros recorridos: <b>{detalleCompletoCpa.kmRecorridos} km.</b></h6>
          <hr />
        </Col>

        <Col md={2}>
          <h6>Cereal: <b>{estadoCpa.cereal}</b></h6>
          <h6>Cereal variedad: <b>{cerealVariedad}</b></h6>
          <hr />
          <h6>Camión: <b>{estadoCpa.camion}</b></h6>
          <h6>Acoplado: <b>{estadoCpa.acoplado}</b></h6>
          <hr />
          <h6>Peso neto origen: <b>{detalleCompletoCpa.pesoNetoOrigen} Kg.</b></h6>
          <h6>Peso bruto origen: <b>{detalleCompletoCpa.pesoBrutoOrigen} Kg.</b></h6>
          <h6>Peso tara origen: <b>{detalleCompletoCpa.pesoTaraOrigen} Kg.</b></h6>

        </Col>
        <Col md={3}>
          <h6>Fecha de ingreso: <b>{fechaDeIngreso}</b></h6>
          <h6>Fecha de alta: <b>{fechaDeAlta}</b></h6>
          <h6>Usuario de ingreso: <b>{detalleCompletoCpa.usuarioIngreso}</b></h6>

          { (estadoCpa.turnoDeSalida)
            ? <h6>Turno de salida: <b>{estadoCpa.turnoDeSalida}</b></h6>
            : <h6>Turno sin cupo: <b>{estadoCpa.turnoSinCupo}</b></h6>
          }
          {fechaAsignacionTurno && <h6>Asignación de turno: <b>{fechaAsignacionTurno}</b></h6>}

          <hr />
          {fechaEgresoPlaya &&
            <h6>Egreso de playa: <b>{fechaEgresoPlaya}</b> </h6>
          }
          {fechaIngresoCalado &&
            <h6>Ingreso a calado: <b>{fechaIngresoCalado}</b> </h6>
          }
          {fechaDeAbandono &&
            <h6> Fecha de abandono: <b>{fechaDeAbandono}</b></h6>
          }

          {fechaDeAbandono &&
            <h6> Motivo de abandono: <b>{detalleCompletoCpa.motivoAbandono}</b></h6>
          }

          {fechaDeAbandono &&
            <h6> Usuario de abandono: <b>{detalleCompletoCpa.usuarioAbandono}</b></h6>
          }
        </Col>
        <Col md={4}>
          <h6>
            Exportador: <b>{estadoCpa.exportador}</b> - CUIT: <b>{estadoCpa.cuitExportador}</b>
          </h6>
          { estadoCpa.titular &&
            <h6>
              Titular de CPE: <b>{estadoCpa.titular}</b> - CUIT: <b>{estadoCpa.cuitTitular}</b>
            </h6>
          }
          {detalleCompletoCpa.contrato && <h6>Contrato: <b>{detalleCompletoCpa.contrato}</b></h6>}
          { estadoCpa.remitenteComercialProductor &&
            <h6>
                            Rte. Comercial Productor: <b>{estadoCpa.remitenteComercialProductor}</b>
                            - CUIT: <b>{estadoCpa.cuitRemitenteComercialProductor}</b>
            </h6>
          }
          {estadoCpa.remitenteComercialVentaPrimaria &&
            <h6>
                            Rte. Comercial Vta. Primaria: <b>{estadoCpa.remitenteComercialVentaPrimaria}</b>
                            - CUIT: <b>{estadoCpa.cuitRemitenteComercialVentaPrimaria}</b>
            </h6>
          }
          { estadoCpa.remitenteComercialVentaSecundaria &&
            <h6>
                            Rte. Comercial Vta. Secundaria: <b>{estadoCpa.remitenteComercialVentaSecundaria}</b>
                            - CUIT: <b>{estadoCpa.cuitRemitenteComercialVentaSecundaria}</b>
            </h6>
          }
          { detalleCompletoCpa.intermediario &&
            <h6>
                            Intermediario: <b>{detalleCompletoCpa.intermediario}</b>
                            - CUIT: <b>{detalleCompletoCpa.intermediarioCuit}</b>
            </h6>
          }
          <h6>Corredor venta primaria: <b>{detalleCompletoCpa.corredorComprador}</b></h6>
          <h6>Corredor venta secundaria: <b>{detalleCompletoCpa.corredorVendedor}</b></h6>
          { estadoCpa.vendedor && <h6>Entregador: <b>{estadoCpa.vendedor}</b> - CUIT: <b>{estadoCpa.cuitVendedor}</b></h6> }
          <hr />
          <h6>Transportista: <b>{estadoCpa.transportista}</b> - CUIT: <b>{estadoCpa.cuitTransportista}</b></h6>
          {detalleCompletoCpa.intermediarioFlete &&
            <h6>Intermediario flete: <b>{detalleCompletoCpa.intermediarioFlete}</b>
                - CUIT: <b>{detalleCompletoCpa.intermediarioFleteCuit}</b></h6>
          }
          <h6>Chofer: <b>{estadoCpa.chofer}</b> - CUIT: <b> {estadoCpa.cuitChofer}</b></h6>
          <h6>Mercado a termino: <b>{detalleCompletoCpa.mercadoATermino}</b>
            {detalleCompletoCpa.mercadoATermino !== 'NO INTERVIENE'
              ? <> - CUIT: <b>{detalleCompletoCpa.mercadoATerminoCuit}</b></>
              : ' '}
          </h6>
          {detalleCompletoCpa.establecimientoDeOrigen && <h6>Establecimiento de origen: <b>{detalleCompletoCpa.establecimientoDeOrigen}</b></h6> }
          {detalleCompletoCpa.contrato && <h6>COntrato: <b>{detalleCompletoCpa.contrato}</b></h6>}

        </Col>
      </Row>
      <Row style={{ marginTop: '1%' }}>
        {fechaDeCalado &&
        <>
          <Col md={3}>
            <h6>Número de muestra: <b>{estadoCpa.numeroDeMuestra}</b></h6>
            <h6>Fecha de calado: <b>{fechaDeCalado}</b></h6>
            <h6>Puesto de calado: <b>{detalleCompletoCpa.puestoDeCalado}</b></h6>
            <h6>Humedad: <b>{detalleCompletoCpa.humedad}</b></h6>
            <h6>Perito calador: <b>{perito}</b></h6>
            { estadoCpa.nombreCalificacionCereal && <h6>Calificación Cereal: <b>{estadoCpa.nombreCalificacionCereal}</b></h6> }
            { detalleCompletoCpa.calleDeCalado && <h6>Calle de calado: <b>{detalleCompletoCpa.calleDeCalado}</b></h6> }
            { fechaCalleCalado && <h6>Asignación de calle: <b>{fechaCalleCalado}</b></h6>}
            <h6>Fumigado: <b>{detalleCompletoCpa.fumigado ? 'Si' : 'No'}</b> - Zarandeo: <b>{detalleCompletoCpa.zarandeo ? 'Si' : 'No'}</b></h6>
            { detalleCompletoCpa.motivoZarandeo && <h6>Motivo zarandeo: <b>{detalleCompletoCpa.motivoZarandeo} </b></h6> }
            <hr />
            { detalleCompletoCpa.rechazoAdministrativoCalado && <h6>Rechazo administrativo: <b>{detalleCompletoCpa.rechazoAdministrativoCalado}</b></h6>}
            { detalleCompletoCpa.usuarioAutorizacionAdministrativaCalado &&
              <h6>Usuario autorización administrativa: <b>{detalleCompletoCpa.usuarioAutorizacionAdministrativaCalado}</b></h6>
            }
            { fechaAutorizacionCalado && <h6>Fecha autorización: <b>{fechaAutorizacionCalado}</b></h6>}
            { fechaEgresoCalado && <h6>Egreso de calado: <b>{fechaEgresoCalado}</b></h6> }
            <hr />
          </Col>

          <Col md={3}>
            { fotoCalado &&
            <Card style={{ marginBottom: '8px' }}>
              <CardActionArea onClick={() => { openDialogFoto(fotoCalado.foto, 'Foto preingreso calado') }}>
                <img src={fotoCalado.foto} alt='Foto preingreso calado' style={{ width: '100%' }} />
              </CardActionArea>
            </Card>
            }
          </Col>
        </>
        }
        { fechaDeBruto &&
        <>
          <Col md={3}>
            { detalleCompletoCpa.balanzaDeBruto && <h6>Balanza: <b>{detalleCompletoCpa.balanzaDeBruto}</b></h6>}
            { fechaDeBruto && <h6>Fecha de bruto: <b>{fechaDeBruto}</b></h6> }
            { detalleCompletoCpa.balanceroDeBruto && <h6>Balancero de bruto: <b>{detalleCompletoCpa.balanceroDeBruto}</b></h6> }
            { detalleCompletoCpa.pesoBrutoTqq && <h6>Peso bruto: <b>{detalleCompletoCpa.pesoBrutoTqq} Kg.</b></h6> }
            { fechaRechazoBruto && <h6>Rechazo en bruto: <b>{fechaRechazoBruto}</b></h6>}
            <hr />
            { fechaDeVolcado && <h6>Fecha de volcado: <b>{fechaDeVolcado}</b> en <b>{estadoCpa.volcadoraCamiones}</b></h6> }
            { detalleCompletoCpa.volcador && <h6>Volcador: <b>{detalleCompletoCpa.volcador}</b></h6> }
            <hr />
            { detalleCompletoCpa.balanzaDeDestare && <h6>Balanza: <b>{detalleCompletoCpa.balanzaDeDestare}</b></h6>}
            { detalleCompletoCpa.balanceroDeDestare && <h6>Balancero: <b>{detalleCompletoCpa.balanceroDeDestare}</b></h6>}
            { fechaDeDestare && <h6>Fecha de destare: <b>{fechaDeDestare}</b></h6> }
            { detalleCompletoCpa.pesoTaraTqq && <h6>Peso tara: <b>{detalleCompletoCpa.pesoTaraTqq} Kg.</b> -  Peso neto: <b>{detalleCompletoCpa.pesoNetoTqq} Kg.</b></h6> }
          </Col>
          <Col md={3}>
            { fotoBruto &&
            <Card>
              <CardActionArea onClick={() => { openDialogFoto(fotoBruto.foto, 'Foto en balanza de bruto') }}>
                <img src={fotoBruto.foto} alt='Foto en balanza de bruto' style={{ width: '100%' }} />
              </CardActionArea>
            </Card>
            }
          </Col>
        </>
        }
      </Row>
    </>
  )
}

export default DatosBusquedaCpa
